import {invokeApi} from "../bl_libs/invokeApi";

export const uploadMedia = (media, progressCb) => {
    let requestObj = {
        path   : '/dq_insider/content/upload',
        method : 'POST',
        headers : {
            'content-type': 'multipart/form-data'
        },
        onUploadProgress: progressCb
    };
    requestObj['postData'] = media;

    return invokeApi(requestObj);
}